<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <mat-card>
        <div class="row message">
          <div class="col-12 text-center">
            <h2>{{ title | translate }}</h2>
            <h4>{{ message | translate }}</h4>
            <h4>
              {{ invitation | translate }}
              <a [href]="link">{{
                company | translate
              }}</a>
            </h4>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
